import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  SidebarModule,
  NavbarModule,
  ScrollbarModule,
  LogoModule,
  AlertModule,
  HeaderModule,
  FooterModule,
  MainContentModule
} from '@michelin/theme';

import { LayoutComponent } from './layout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    AlertModule,
    NavbarModule,
    LogoModule,
    ScrollbarModule,
    HeaderModule,
    FooterModule,
    MainContentModule
  ],
  providers: [],
  declarations: [LayoutComponent]
})
export class LayoutModule {}
